/* =============================================
   CEYLERA SHOPIFY THEME — theme.js
   ============================================= */

(function () {
  'use strict';

  /* ─── Announcement Bar Height ───────────── */
  const announcementBar = document.querySelector('.announcement-bar');
  function setAnnouncementBarHeight() {
    if (!announcementBar) return;
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      announcementBar.offsetHeight + 'px'
    );
  }
  setAnnouncementBarHeight();
  window.addEventListener('resize', setAnnouncementBarHeight, { passive: true });

  /* ─── Transparent Header ─────────────────── */
  const header  = document.getElementById('site-header');
  const hero    = document.querySelector('.hero');
  const eyebrow = hero && hero.querySelector('.hero__eyebrow');

  function updateEyebrow() {
    if (!eyebrow || !header) return;
    const top   = eyebrow.getBoundingClientRect().top;
    const limit = header.getBoundingClientRect().bottom;
    const fade  = 32;
    // Fade out when the eyebrow enters the header zone
    eyebrow.style.opacity = top <= limit + fade
      ? String(Math.max(0, (top - limit) / fade))
      : '';
  }

  function updateHeaderTransparency() {
    if (!header) return;
    if (hero) {
      const heroBottom = hero.getBoundingClientRect().bottom;
      header.classList.toggle('is-transparent', heroBottom > header.getBoundingClientRect().bottom);
    }
    updateEyebrow();
  }

  function updateScrolledState() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 0 || !hero);
  }

  if (hero && header) {
    updateHeaderTransparency();
    window.addEventListener('scroll', updateHeaderTransparency, { passive: true });
  } else if (header) {
    // No hero on this page — remove is-transparent so header is always solid
    header.classList.remove('is-transparent');
  }

  updateScrolledState();
  window.addEventListener('scroll', updateScrolledState, { passive: true });

  /* ─── Mobile Nav ─────────────────────────── */
  const mobileNav     = document.getElementById('mobile-nav');
  const menuBtn       = document.getElementById('menu-btn');
  const mobileClose   = document.getElementById('mobile-nav-close');
  const mobileBack    = document.querySelector('.mobile-nav__backdrop');
  const mobileDrawer  = mobileNav && mobileNav.querySelector('.mobile-nav__drawer');
  let mobileNavReturnFocus = null;

  function openNav() {
    if (!mobileNav) return;
    mobileNavReturnFocus = document.activeElement;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    if (mobileClose) mobileClose.focus({preventScroll:true});
  }

  function closeNav() {
    if (!mobileNav || !mobileNav.classList.contains('is-open')) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    var returnFocus = mobileNavReturnFocus;
    mobileNavReturnFocus = null;
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({preventScroll:true});
    else if (menuBtn) menuBtn.focus({preventScroll:true});
  }

  if (menuBtn)     menuBtn.addEventListener('click', openNav);
  if (mobileClose) mobileClose.addEventListener('click', closeNav);
  if (mobileBack)  mobileBack.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (!mobileNav || !mobileNav.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeNav();
      return;
    }
    if (e.key === 'Tab' && mobileDrawer) {
      var focusables = Array.prototype.slice.call(mobileDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary'));
      focusables = focusables.filter(function (el) {
        return el.getClientRects().length > 0;
      });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || !mobileDrawer.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !mobileDrawer.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    }
  });

  document.querySelectorAll('.mobile-nav__links a').forEach(function (a) {
    a.addEventListener('click', closeNav);
  });

  /* ─── Hero Parallax ──────────────────────── */
  const heroMedia   = hero && hero.querySelector('.hero__media video, .hero__media img');
  const heroContent = hero && hero.querySelector('.hero__inner');
  let ticking = false;

  function runParallax() {
    if (window.innerWidth <= 768) {
      if (heroMedia)   heroMedia.style.transform   = '';
      if (heroContent) heroContent.style.transform = '';
      return;
    }
    const sy = window.scrollY;
    if (heroContent) {
      heroContent.style.transform = 'translateY(' + (sy * 0.26) + 'px)';
    }
    if (heroMedia) {
      heroMedia.style.transform = 'scale(' + (1 + sy * 0.00005) + ') translateY(' + (sy * 0.1) + 'px)';
    }
    ticking = false;
  }

  if (hero) {
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(runParallax); ticking = true; }
    }, { passive: true });
  }

  /* ─── Scroll-to-top button ──────────────── */
  var scrollTopBtn = document.getElementById('scroll-top-btn');
  if (scrollTopBtn) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        scrollTopBtn.classList.add('is-visible');
      } else {
        scrollTopBtn.classList.remove('is-visible');
      }
    }, { passive: true });

    scrollTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ─── Scroll Reveal ──────────────────────── */
  var revealSelectors = [
    '.card', '.testimonial', '.origin-card',
    '.section-heading', '.section-subheading',
    '.trust-strip__item', '.image-with-text__content'
  ];
  var revealEls = document.querySelectorAll(revealSelectors.join(','));

  if ('IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach(function (el) { el.classList.add('reveal'); });

    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var delay = (i % 4) * 80;
          setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    revealEls.forEach(function (el) { revealObs.observe(el); });
  }

  /* ─── Product Filter ─────────────────────── */
  document.querySelectorAll('.filter-bar__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var filter = btn.dataset.filter || 'all';
      document.querySelectorAll('.filter-bar__btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      document.querySelectorAll('.card[data-type]').forEach(function (card) {
        if (filter === 'all' || card.dataset.type === filter) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });
    });
  });

  /* ─── Quantity Selector ──────────────────── */
  document.querySelectorAll('.qty-selector').forEach(function (qs) {
    if (qs.dataset.qtySelectorBound === 'true') return;
    qs.dataset.qtySelectorBound = 'true';

    var input = qs.querySelector('.qty-selector__input');
    if (!input) return;
    var min = parseInt(input.min, 10);
    var fallback = Number.isNaN(min) ? 0 : min;

    var minus = qs.querySelector('.qty-selector__btn--minus');
    var plus  = qs.querySelector('.qty-selector__btn--plus');

    if (minus) {
      minus.addEventListener('click', function () {
        var parsed = parseInt(input.value, 10);
        var v = Number.isNaN(parsed) ? fallback : parsed;
        if (v > fallback) { input.value = v - 1; input.dispatchEvent(new Event('change')); }
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var parsed = parseInt(input.value, 10);
        var v = Number.isNaN(parsed) ? fallback : parsed;
        input.value = v + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  /* ─── Cart Drawer ────────────────────────── */
  var cartDrawer         = document.getElementById('CartDrawer');
  var cartDrawerBody     = document.getElementById('CartDrawerBody');
  var cartDrawerFoot     = document.getElementById('CartDrawerFoot');
  var cartDrawerClose    = document.getElementById('CartDrawerClose');
  var cartDrawerBackdrop = document.getElementById('CartDrawerBackdrop');
  var cartReadVersion = 0;
  var cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function readCart() {
    var version = ++cartReadVersion;
    return fetch(cartRoot + 'cart.js?_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart refresh failed: ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (version !== cartReadVersion) return null;
        _updateBadge(cart.item_count);
        return cart;
      });
  }

  function _escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function _fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function _cartImg(url) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_144x144$1$3');
  }
  function _updateBadge(count) {
    count = parseInt(count, 10) || 0;
    document.querySelectorAll('.cart-badge').forEach(function (badge) {
      badge.textContent = count;
      if (count > 0) badge.removeAttribute('hidden');
      else           badge.setAttribute('hidden', '');
    });
    var btn = document.getElementById('CartIconBtn');
    if (btn) btn.setAttribute('aria-label', 'Open cart (' + count + ' items)');
    var countEl = document.getElementById('CartDrawerCount');
    if (countEl) countEl.textContent = count ? '(' + count + ')' : '';
  }

  /* Re-reads the cart and updates the header count. Safe to call after any
     /cart/add|change|update request, whether or not the drawer exists. */
  function refreshCartCount() {
    return readCart().catch(function () {});
  }
  window.refreshCartCount = refreshCartCount;
  document.addEventListener('cart:updated', refreshCartCount);
  /* Pages restored from the back/forward cache keep a stale count. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
  document.addEventListener('shopify:section:load', refreshCartCount);
  refreshCartCount();

  function _renderCart(cart) {
    if (!cart) return;
    _updateBadge(cart.item_count);
    cartDrawerBody = document.getElementById('CartDrawerBody');
    cartDrawerFoot = document.getElementById('CartDrawerFoot');
    if (!cartDrawerBody) return;

    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (cartDrawerFoot) cartDrawerFoot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = _cartImg(item.image);
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + _escHtml(item.variant_title) + '</p>' : '';
      html += '<div class="cart-drawer__item" data-key="' + _escHtml(item.key) + '">';
      html += img
        ? '<img src="' + _escHtml(img) + '" alt="' + _escHtml(item.title) + '" class="cart-drawer__item-img" width="72" height="72" loading="lazy">'
        : '<div class="cart-drawer__item-img"></div>';
      html += '<div class="cart-drawer__item-info">'
        + '<a href="' + _escHtml(item.url) + '" class="cart-drawer__item-title">' + _escHtml(item.product_title) + '</a>'
        + variant
        + (item.selling_plan_allocation ? '<p class="cart-drawer__item-variant">Subscribe &amp; Save · ' + _escHtml(item.selling_plan_allocation.selling_plan.name) + '</p>' : '')
        + '<div class="cart-drawer__item-row">'
        + '<div class="cart-drawer__qty">'
        + '<button type="button" class="cart-drawer__qty-btn" data-action="minus" aria-label="Decrease quantity">&minus;</button>'
        + '<span class="cart-drawer__qty-val">' + item.quantity + '</span>'
        + '<button type="button" class="cart-drawer__qty-btn" data-action="plus" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '<span class="cart-drawer__item-price">' + _fmtMoney(item.final_line_price) + '</span>'
        + '</div>'
        + '<button type="button" class="cart-drawer__remove" aria-label="Remove ' + _escHtml(item.title) + '">Remove</button>'
        + '</div></div>';
    });
    cartDrawerBody.innerHTML = html;

    cartDrawerBody.querySelectorAll('.cart-drawer__item').forEach(function (row) {
      var key    = row.dataset.key;
      var qtyVal = row.querySelector('.cart-drawer__qty-val');
      row.querySelector('[data-action="minus"]').addEventListener('click', function () {
        _changeCartItem(key, Math.max(0, parseInt(qtyVal.textContent, 10) - 1));
      });
      row.querySelector('[data-action="plus"]').addEventListener('click', function () {
        _changeCartItem(key, parseInt(qtyVal.textContent, 10) + 1);
      });
      row.querySelector('.cart-drawer__remove').addEventListener('click', function () {
        _changeCartItem(key, 0);
      });
    });

    var subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (subtotalEl) subtotalEl.textContent = _fmtMoney(cart.total_price);
    if (cartDrawerFoot) cartDrawerFoot.hidden = false;
  }

  function _changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(_renderCart).catch(function () {});
  }

  function openCartDrawer() {
    var refresh = readCart().then(_renderCart).catch(function () {});
    cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return refresh;
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  window.openCartDrawer  = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  var cartIconBtn = document.getElementById('CartIconBtn');
  if (cartIconBtn)        cartIconBtn.addEventListener('click', openCartDrawer);
  if (cartDrawerClose)    cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
  });

  /* ─── Discount code (drawer) ────────────────────────────────────── */
  var DRAWER_DISCOUNT_KEY = 'ceylera_discount_code';

  function _sanitizeDrawerDiscount(raw) {
    return String(raw || '').trim().slice(0, 255);
  }

  (function () {
    var input    = document.getElementById('CartDrawerDiscountCode');
    var btn      = document.getElementById('CartDrawerApplyDiscount');
    var msgEl    = document.getElementById('CartDrawerDiscountMsg');
    var checkout = document.getElementById('CartDrawerCheckout');
    if (!input || !btn) return;

    function showMsg(text, ok) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.style.color = ok ? 'var(--c-green-mid)' : 'var(--c-muted)';
    }

    try {
      var saved = sessionStorage.getItem(DRAWER_DISCOUNT_KEY);
      if (saved) { input.value = saved; showMsg('Code saved — will be applied at checkout.', true); }
    } catch (e) {}

    btn.addEventListener('click', function () {
      var code = _sanitizeDrawerDiscount(input.value);
      input.value = code;
      if (code) {
        try { sessionStorage.setItem(DRAWER_DISCOUNT_KEY, code); } catch (e) {}
        showMsg('Code saved — will be applied at checkout.', true);
      } else {
        try { sessionStorage.removeItem(DRAWER_DISCOUNT_KEY); } catch (e) {}
        showMsg('', false);
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });

    if (checkout) {
      checkout.addEventListener('click', function (e) {
        try {
          var code = sessionStorage.getItem(DRAWER_DISCOUNT_KEY);
          if (code) {
            e.preventDefault();
            window.location.href = '/checkout?discount=' + encodeURIComponent(code);
          }
        } catch (err) {}
      });
    }
  }());

  /* ─── Quick Add ────────────────────── */
  /* Delegated so cards re-rendered by the theme editor or added later still work. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.card__quick-add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId    = btn.dataset.variantId;
    var variantIdNum = parseInt(variantId, 10);
    if (!variantId || Number.isNaN(variantIdNum)) {
      var dest = btn.dataset.productUrl || '';
      if (dest && dest.startsWith('/') && !dest.startsWith('//')) window.location.href = dest;
      return;
    }
    btn.disabled = true;
    var label = btn.dataset;
    var originalText = label.addText || 'Add to Cart';
    var message = btn.parentElement.querySelector('[data-cart-add-error]');
    if (message) {
      message.hidden = true;
      message.textContent = '';
    }
    btn.removeAttribute('title');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = label.addingText || 'Adding…';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantIdNum, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) {
            var error = new Error(data.description || data.message || label.errorText);
            error.status = r.status;
            throw error;
          }
          return data;
        });
      })
      .then(function () {
        ++cartReadVersion;
        btn.textContent = label.addedText || '✓ Added';
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800);
        try {
          openCartDrawer();
        } catch (error) {
          refreshCartCount();
        }
      }, function (err) {
        btn.textContent = label.retryText || 'Try again';
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (message) {
          message.textContent = (err.status ? err.message || label.errorText : label.unknownText) + ' ';
          var cartLink = document.createElement('a');
          cartLink.href = cartRoot + 'cart';
          cartLink.textContent = label.viewCartText;
          message.appendChild(cartLink);
          message.hidden = false;
        }
      });
  });

  /* ─── Article Share: Copy Link ─────────────── */
  var copyLinkBtn = document.querySelector('.art-share__btn--copy');
  if (copyLinkBtn) {
    var _copyIcon = copyLinkBtn.querySelector('svg');
    copyLinkBtn.addEventListener('click', function () {
      var url = copyLinkBtn.dataset.url;
      if (!url) return;
      function onCopied() {
        var prevContent = copyLinkBtn.textContent;
        copyLinkBtn.textContent = 'Copied!';
        setTimeout(function () {
          copyLinkBtn.textContent = '';
          if (_copyIcon) copyLinkBtn.appendChild(_copyIcon);
          copyLinkBtn.appendChild(document.createTextNode(' Copy link'));
        }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(onCopied).catch(function () {
          _fallbackCopyText(url, onCopied);
        });
      } else {
        _fallbackCopyText(url, onCopied);
      }
    });
  }

  function _fallbackCopyText(text, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    if (ok && onSuccess) onSuccess();
  }

  /* ─── Footer Country/Currency Selector ──── */
  const localizationSelect = document.querySelector('.site-footer__localization-select');
  if (localizationSelect) {
    localizationSelect.addEventListener('change', function () {
      localizationSelect.closest('form').submit();
    });
  }

  /* ─── Newsletter Form ────────────────────── */
  document.querySelectorAll('.newsletter form, .newsletter__form').forEach(function (form) {
    // Shopify handles the form; this only intercepts if action is missing
    if (!form.action || form.action.includes('#')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        if (!input || !input.value.trim()) return;
        var msg = document.createElement('p');
        msg.style.cssText = 'color:var(--c-gold-light);font-size:.88rem;padding:1.1rem 0;letter-spacing:.05em';
        msg.textContent = 'Thank you — check your inbox for your discount code.';
        while (form.firstChild) { form.removeChild(form.firstChild); }
        form.appendChild(msg);
      });
    }
  });

})();

